import Associada from "./componentesAssociada.config";
import Cooperada from "./componentesCooperada.config";
import Executora from "./componentesExecutora.config";
import Proponente from "./componentesProponente.config";

export default {
    'associada' : Associada,
    'cooperada' : Cooperada,
    'executora' : Executora,
    'proponente' : Proponente
}